module.exports = __webpack_public_path__ + "static/media/ic_dashboard.b4349b8c.svg";